import styled from "styled-components";
import "react-time-picker/dist/TimePicker.css";
import "react-clock/dist/Clock.css";

export const TimePickerContainer = styled.div`
  .react-time-picker__wrapper {
    border: 1px solid #d8d8d8;

    input[type="number"] {
      outline: none;
    }

    .react-time-picker__button__icon {
      stroke: ${({ theme }) => theme.input.icon.clear};
    }
  }

  .react-time-picker--disabled {
    background: transparent;
    color: ${({ theme }) => theme.card.font.tertiary};
  }
`;
